import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=bb763502&scoped=true&"
import script from "./profile.vue?vue&type=script&lang=js&"
export * from "./profile.vue?vue&type=script&lang=js&"
import style0 from "./profile.vue?vue&type=style&index=0&lang=css&"
import style1 from "./profile.vue?vue&type=style&index=1&id=bb763502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb763502",
  null
  
)

export default component.exports